import { API_BASE_URL, STUDENT_REGISTER_ENDPOINT } from "../../../utils/API_CONSTANTS";

class APIError extends Error {
  constructor(message, statusCode) {
    super(message);
    this.name = "APIError";
    this.statusCode = statusCode;
  }
}

const StudentDetails = async (token, body) => {
  try {
    if (!token || typeof token !== 'string') {
      throw new APIError("Invalid token provided", 400);
    }
    const formData = new FormData();
    
    // Loop through the body object and append each key-value pair to FormData
    Object.keys(body).forEach(key => {
      formData.append(key, body[key]);
    });

    // Send the request body as JSON
    const response = await fetch(API_BASE_URL + STUDENT_REGISTER_ENDPOINT, {
      method: "POST",
      headers: {
        //"Content-Type": "application/json",  // Specify JSON in Content-Type
        "token": token,  // Send the token in the 'token' header
      },
      body: formData  // Convert body object to JSON string
    });

    const data = await response.json();

    if (!response.ok) {
      throw new APIError(data.message || "An error occurred during registration.", response.status);
    }

    return data;
  } catch (error) {
    // console.error(error.message);
    throw new APIError(error.message || "An unknown error occurred.", error.statusCode || 500);
  }
};

export default StudentDetails;

